import { Component } from '@angular/core';
import { CompareProductsFacade, ProductDataForBar } from '@cpak/main-features-lib/data-store';
import { Observable, take } from 'rxjs';
import { ButtonNamesGA, maximumNumberOfProductsToCompare, ModalNamesGA, ratingConfig } from '@cpak/consts';
import { Router } from '@angular/router';
import { RoutingUrls } from '@cpak/enums';
import { MODAL_NAME } from '@cpak/shared/injectors';

@Component({
  selector: 'cpak-compare-products-bar',
  templateUrl: './compare-products-bar.component.html',
  styleUrls: ['./compare-products-bar.component.scss'],
  providers: [
    {
      provide: MODAL_NAME,
      useValue: ModalNamesGA.CompareSelectedItems,
    },
  ],
})
export class CompareProductsBarComponent {
  public readonly maxRating = ratingConfig.maxRating;
  public productsToCompare$: Observable<ProductDataForBar[]>;
  public maximumNumberOfProductsToCompare = maximumNumberOfProductsToCompare;

  public readonly ButtonNamesGA = ButtonNamesGA;

  constructor(private compareProductsFacade: CompareProductsFacade, private router: Router) {
    this.productsToCompare$ = this.compareProductsFacade.getProductsDataForBar();
  }

  public navigateToComparePage(): void {
    this.productsToCompare$.pipe(take(1)).subscribe(products => {
      const ids = products.map(product => product.id);
      this.router.navigate([RoutingUrls.CompareProducts], { queryParams: { products: ids } });
    });
  }

  public removeProductFromComparison(event: Event, productId: string): void {
    event.stopPropagation();
    this.compareProductsFacade.removeProductFromComparison(productId);
  }

  public removeAllProductsFromComparison(): void {
    this.compareProductsFacade.removeAllProductsFromComparison();
  }

  public openInCatalog(productId: string): void {
    if (!productId) return;
    this.router.navigate([RoutingUrls.Catalog, 'products', productId]);
  }
}
